import { AssetTypeSearchComponentBase } from './asset-type-search.component.base';
import { Component, Injector } from '@angular/core';
import { FormBuilder, FormControl } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { FormStorage, UserStorage } from '@scisys-uim/uim-common';
import { AssetTypeService, RefCodeStorage } from 'assets-service';


@Component({
  selector: 'app-asset-type-search',
  templateUrl: './asset-type-search.component.html',
  styleUrls: ['./asset-type-search.component.scss']
})
export class AssetTypeSearchComponent extends AssetTypeSearchComponentBase {

  displayedColumns: string[] = ['assetTypeId', 'name', 'electricalAspectRequirement', 'portableApplianceTestingDays', 'mechanicalAspectRequirement', 'wbv', 'wbvRagStatus', 'havs', 'havsRagStatus', 'maintenanceAspectRequirement', 'maintenanceType', 'visualInspection', 'periodicMaintenance', 'periodicMaintenanceDays', 'routineMaintenance', 'routineMaintenanceDays', 'guidanceText', 'comments', 'updatedBy', 'updatedDate', 'createdBy', 'createdDate', 'actions'];
  disabledColumns: string[] = ['assetTypeId', 'comments', 'createdBy', 'createdDate', 'guidanceText', 'havs', 'havsRagStatus', 'maintenanceType', 'periodicMaintenance', 'periodicMaintenanceDays', 'portableApplianceTestingDays', 'routineMaintenance', 'routineMaintenanceDays', 'visualInspection', 'wbv', 'wbvRagStatus',];


  constructor(protected route: ActivatedRoute,
    protected router: Router,
    protected userStorage: UserStorage,
    protected dialog: MatDialog,
    protected assetTypeService: AssetTypeService,
    protected refCodeStorage: RefCodeStorage,
    protected fb: FormBuilder,
    protected formStorage: FormStorage,
    protected injector: Injector) {
    super(route, router, userStorage, dialog, assetTypeService, refCodeStorage, fb, formStorage, injector);
  }

  protected onInitAsyncComplete() {
    super.onInitAsyncComplete();
    this.maintenanceTypeLoadSelectionList();
    this.electricalAspectRequirementLoadSelectionList();
    this.mechanicalAspectRequirementLoadSelectionList();
    this.maintenanceAspectRequirementLoadSelectionList();

    if (!this.restoreFormFromParams(this.searchForm)) {
      this.resetSearchForm();
      this.restoreFormChanges();
    }
  }

  resetSearchForm() {
    // placeholder
  }

  protected transformParamsToModelSetters(params: Params): {
    [key: string]: (value: any, formControl: FormControl, formControlName: string) => void
  } {
    return this.transformAllPropertiesToModelSetters();
  }

}



